const convertLatLongToMeter = ([lat, lng], referenceLat) => {
  const latMeters = lat * 111320;
  const lngMeters = lng * (111320 * Math.cos((referenceLat * Math.PI) / 180));
  return [latMeters, lngMeters];
};

export default convertLatLongToMeter;
